// Footer.js
import React from 'react';
import { IconVolume, IconVolumeOff } from '@tabler/icons-react';

const Footer = ({ isVolumeOn, toggleVolume }) => {
  return (
    <div className='footer' onClick={toggleVolume}>
      {isVolumeOn ? <IconVolume className='icon-hover'/> : <IconVolumeOff color="#FA5352" className='icon-hover' />}
    </div>
  );
};

export default Footer;
